import {
    isTranslatableImageKeyReference,
    isTranslatableImageValue,
} from '../components/question-visual-editor/questionDefinitionToTranslationKeys';

function isImageTranslationKey(translationKey) {
    if (!translationKey) return false;
    if (Array.isArray(translationKey)) {
        return translationKey.some((key) => isImageTranslationKey(key));
    }
    return (
        isTranslatableImageValue(translationKey) ||
        isTranslatableImageKeyReference(translationKey)
    );
}

/** Language codes to try when resolving ui.translation.* overrides (current → base → en for images). */
export function translationOverrideLanguageCodes(lng, translationKey) {
    const codes = [];
    if (lng) {
        codes.push(lng);
        const base = lng.split('-')[0];
        if (base && base !== lng) codes.push(base);
    }
    if (isImageTranslationKey(translationKey) && !codes.includes('en')) {
        codes.push('en');
    }
    if (!codes.length) codes.push('en');
    return [...new Set(codes)];
}

export function getTranslationOverrideFromSource(
    source,
    lng,
    translationKey
) {
    if (!source || !translationKey) return undefined;
    for (const language of translationOverrideLanguageCodes(lng, translationKey)) {
        const fullKey = `ui.translation.${language}.${translationKey}`;
        const override = source[fullKey];
        if (override !== undefined && override !== null && override !== '') {
            return override;
        }
    }
    return undefined;
}
